import mock from 'src/utils/mock';
import { Panel as PanelInterface } from 'src/types/panel';
const panel: PanelInterface[] = [
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5011,
        DisplayName: 'Arthritis Profile',
        Description: 'Arthritis Profile',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5008,
        DisplayName: 'Electrolytes Panel',
        Description: 'Electrolytes Panel',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5015,
        DisplayName: 'Iron Studies',
        Description: 'Iron Studies',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5006,
        DisplayName: 'Kidney Function Test (KFT)',
        Description: 'Kidney Function Test (KFT)',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5007,
        DisplayName: 'Lipid Profile',
        Description: 'Lipid Profile',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5005,
        DisplayName: 'Liver Function Test (LFT)',
        Description: 'Liver Function Test (LFT)',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5012,
        DisplayName: 'Protein Fraction',
        Description: 'Protein Fraction',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelID: 5014,
        DisplayName: 'Torch Profile',
        Description: 'Torch Profile',
        Spl_Remarks: '',
        PanelCatg: 'Biochemistry',
        CreationDt: '2023-06-20T13:07:53.807Z',
        ValidFrom: '2023-05-01T00:00:00.000Z',
        ValidUpto: '2199-05-01T00:00:00.000Z',
        RevNo: 0,
    },
];

mock.onPost('/getPanels/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, panel]);
        }, 1000);
    });
});
mock.onPost('/getPanel/').reply((config) => {
    const params = JSON.parse(config.data);
    const panelData = panel.filter((item) => item.PanelID === params.id)[0];
    return [200, { ...panelData }];
});
